import * as z from "zod"
import { CargoType, CargoTypeSub, CargoCoolingRange, AircraftRestriction, ServiceType, RateCategory, ExpiryReason, SurchargeCategory } from "@prisma/client"

export const RateModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  provider_id: z.string(),
  account_id: z.number().int().nullish(),
  lane_id: z.number().int().nullish(),
  airline_product: z.string().nullish(),
  airline_service: z.string().nullish(),
  airline_ref: z.string().nullish(),
  cargo_type: z.nativeEnum(CargoType),
  cargo_type_sub: z.nativeEnum(CargoTypeSub).nullish(),
  cargo_cooling_ranges: z.nativeEnum(CargoCoolingRange).array(),
  classes: z.string().array(),
  aircraft_restrictions: z.nativeEnum(AircraftRestriction).array(),
  service_type: z.nativeEnum(ServiceType),
  rate_category: z.nativeEnum(RateCategory),
  starts_at: z.date(),
  expires_at: z.date().nullish(),
  expiry_reason: z.nativeEnum(ExpiryReason).nullish(),
  expiry_comment: z.string().nullish(),
  replaced_by_id: z.number().int().nullish(),
  replacement_initiated_at: z.date().nullish(),
  origin_airport_id: z.string().nullish(),
  destination_airport_id: z.string().nullish(),
  min_cost: z.number().int().nullish(),
  comments: z.string().nullish(),
  hash: z.string().nullish(),
  surcharge_categories: z.nativeEnum(SurchargeCategory).array(),
  import_id: z.number().int().nullish(),
})
